const _ = require('lib/underscore')
const tokenize = require('lib/html/tokenizer')
const stringify = require('lib/html/token_stringifier')
const log = require('log').create('html sanitizer') // eslint-disable-line

// sanitize_bio:
//
// this module leverages lib/html/tokenizer to convert an html string into a
// nested array of tokens representing the DOM nodes that would be created by
// the html. it then passes those tokens to lib/html/token_stringifier, passing
// options to ignore some tags and unwrap others.
//
// e.g. '<span>foo</span>' => 'foo')
//
// before tokenizing it does some premassaging with regex

const regex = {
    mailto: /^mailto:/gim,
    newlines: /(\n|\r)/gim,
    breaks: /<br *\/?>/gim,
    nbsp: /&nbsp;/gim,
    whitespace: /\s+/gim,
    empty_tags: /<([^/\s>]+)[^>]*><\/\1>/gim,
    dupe_tags: /<(\/?)([^/\s>]+[^>]*)><\1\2>/gim,
    multiple_brs: /(\s*<br *\/?>\s*){2,}/gim,
    div: /<(\/?)(div)([^>]*)>/gim,
    brs_at_start_of_p: /(<p[^>]*>)(\s*<br\s*\/?>\s*)+/gim,
    brs_at_end_of_p: /(\s*<br\s*\/?>\s*)+(<\/p[^>]*>)/gim,
}

const default_stringify_options = {
    max_length: 5000,
    exclude_empty_tags: true,
    allowed_tags: {
        P: true,
        A: true,
        BR: true,
        B: true,
        STRONG: true,
        I: true,
        H2: true,
        H3: true,
        OL: true,
        UL: true,
        LI: true,
        HR: true,
    },
    disallowed_tags: null,
    unwrapped_tags: {
        SPAN: true,
        U: true,
        EM: true,
        FONT: true,
    },
    allowed_attributes: {
        P: {},
        A: {
            href: true,
        },
        B: {},
        STRONG: {},
        I: {},
        BR: {},
        H2: {},
        H3: {},
        OL: {},
        UL: {},
        LI: {},
        HR: {},
    },
    disallowed_attributes: null,
    required_attributes: {
        A: {
            target: '_blank',
            rel: 'nofollow noopener noreferrer',
        },
    },
    massageTextContent(txt) {
        return (
            txt
                .replace(regex.nbsp, ' ')
                .replace(regex.whitespace, ' ')
        )
    },
    massageElementContent(txt) {
        return txt.trim()
    },
}

function premassageHtml(html) {
    // massage string before parsing
    return (
        html
        // convert divs to paragraphs
            .replace(regex.div, '<$1p$3>')
        // strip newlines
            .replace(regex.newlines, '')
        // convert multiple breaks to paragraphs
            .replace(regex.multiple_brs, '</p><p>')
        // remove breaks at start and end of paragraphs
            .replace(regex.brs_at_start_of_p, '$1')
            .replace(regex.brs_at_end_of_p, '$2')
            .trim()
    )
}


function sanitize(html, options = {}) {
    if (! html) return ''
    const massaged = premassageHtml(`<p>${html}</p>`)
    const tokens = tokenize(massaged)
    _.defaults(options, default_stringify_options)
    return stringify(tokens, options).trim()
}

module.exports = sanitize
